import { render } from "./ItemActiviteRecentes.vue?vue&type=template&id=7013de5d"
import script from "./ItemActiviteRecentes.vue?vue&type=script&lang=js"
export * from "./ItemActiviteRecentes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__